import axios from 'axios';

const helpers = {
  getIpClient: async () => {
    axios.get('https://api.ipify.org/?format=json')
    .then(response => response.data.ip)
    .catch(error => console.log(error))
  }
}

export default helpers;
